import { useState } from "react"
import { HxMapGroup } from "../../../../Comps/HxMap/HxMapGroup"
import { HexMap } from "../../../../Data/HexMap/HexMap"
import { HexMapBuilderParams, BuildHexMap } from "../../../../Data/HexMap/HexMapBuilder"
import { HexMapModifier } from "../../../../Data/HexMap/HexMapModifier"
import { FlexRowTwo } from "../../../../Layouts/FlexRows"
import { All } from "../../../../Util/Constants/Quantities"
import { Music, useScaleNotes } from "../../../../Util/Music/Music"
import { TransformTranslate } from "../../../../Util/Transform/Transform"
import { Note } from "../../../../Data/HexMap/Note"
import { produce } from "immer"
import { useNoteNames } from "../../../../Project/ProjectStore"
import { NotesSelectMenu } from "../../../../Comps/NoteButtons/NotesSelect"
import { IconEye } from "../../../../Comps/Icons/IconEye"
import { CommonNotes } from "../CommonNotes"
import { CommonChords } from "../CommonChords"

export function CycleOfFifthsPair(){ 
    const [tonic, setTonic] = useState(Music.G)
    const getAdjustedTonic = (t:number) => { return (t + 3) % 12 }
    const getMap = () => {
        const params:HexMapBuilderParams = {rows:2, columns:2, tonic:getAdjustedTonic(tonic), radius:80}
        const map:HexMap = BuildHexMap(params)
        const mod:HexMapModifier = new HexMapModifier(map)
        mod.keys_setOpen([All], false)
        mod.keys_setOpen([1,2], true)
        mod.keys_setVisible([0,3], false)
        //mod.notes_setPrimaryLabelAsNoteIndex([All])
        return map
    }
    const [map, setMap] = useState<HexMap>(getMap())
    const [width,height] = [300,400]
    const onNoteClick = (note:Note) => {
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.notes_advanceSelectedState([note.params.noteIndex])
        }))
    }
    const resetTonic = (t:number) => {
        setTonic(t)
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.setTonic(getAdjustedTonic(t))
        }))
    }
    const commonNoteIndexes:number[] = [2,5,7,8,9,10,11,12,13,14]
    const showCommonNotes = () => {
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.notes_setDefault([All])
            mod.notes_setSelected(commonNoteIndexes)
        }))
    }
    const noteNames:string[] = useNoteNames()
    const commonChordIndexes:number[] = [2,5,7,9,10,14]
    const showCommonChords = () => {
        const noteIndexes:number[] = commonChordIndexes
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.notes_setDefault([All])
            mod.notes_setHilited(noteIndexes)
        }))
    }
    const showNotes = (noteIndexes:number[]) => {
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.notes_setDefault([All])
            mod.notes_setHilited(noteIndexes)
        }))
    }
    const topTonicNote:string = noteNames[tonic]
    const bottomTonicNote:string = noteNames[(tonic + 7) % 12]
    const scale:string[] = useScaleNotes(tonic)
    const clear = () => {
        setMap(getMap())
    }
    return(
        <div className={'harmonic-cycle-pair'}>
            <FlexRowTwo columnOneFlex={1} columnTwoFlex={1}>
               <div className={'centered'} style={{marginTop:30}}> 
                    <div><NotesSelectMenu onChange={resetTonic} tonic={tonic}/></div>
                    <svg width={width} height={height} className={'pair-hexmap'}>
                        <g transform={TransformTranslate(width/3, height/2)}>
                            <HxMapGroup hexMap={map} onNoteClick={onNoteClick}/>
                        </g>
                    </svg>
                    <div><button style={{marginTop:25}} type='button' onClick={clear}>Clear</button></div>
                </div>
                <div className={'pair-description'}>
                    <h2>Properties of Two Keys Along the Circle of Fifths</h2>
                    <ul>
                        <li>Common Notes: 6 of 7 <CommonNotes map={map} noteIndexes={commonNoteIndexes}/> <IconEye onClick={showCommonNotes}/></li>
                        <li>Common Chords: 4 of 7 <CommonChords map={map} noteIndexes={commonChordIndexes}/> <IconEye onClick={showCommonChords}/></li>
                        <li>The bottom key ({bottomTonicNote}) is a fifth higher (7 notes) than the top key ({topTonicNote}).</li>
                        <li>Each note in the bottom key ({bottomTonicNote}) is a fifth higher than its counterpart in the top key ({topTonicNote}).</li>
                    </ul>
                    <h2>Common Modulation Techniques:</h2>
                    <ul>
                        <li>Using one of the four common chords as a pivot chord.</li>
                    </ul>
                    <h2>Parallel Modes (top key to bottom key):</h2>
                    <ul>
                        <li>
                            {scale[0]} Ionian (major) in {topTonicNote} and {scale[0]} Lydian in {bottomTonicNote} 
                            <IconEye onClick={()=>{showNotes([7,5])}}/>
                        </li>
                        <li>
                            {scale[1]} Dorian in {topTonicNote} and {scale[1]} Mixolydian in {bottomTonicNote} 
                            <IconEye onClick={()=>{showNotes([8,13])}}/>
                        </li>
                        <li>
                            {scale[2]} Phrygian in {topTonicNote} and {scale[2]} Aeolian (minor) in {bottomTonicNote} 
                            <IconEye onClick={()=>{showNotes([9,14])}}/>

                        </li>
                        <li>
                            {scale[4]} Mixolydian in {topTonicNote} and {scale[4]} Ionian (major) in {bottomTonicNote} 
                            <IconEye onClick={()=>{showNotes([2])}}/>
                        </li>
                        <li>
                            {scale[5]} Aeolian in {topTonicNote} and {scale[5]} Dorian in {bottomTonicNote} 
                            <IconEye onClick={()=>{showNotes([10])}}/>
                        </li>
                        <li>
                            {scale[6]} Locrian in {topTonicNote} and {scale[6]} Phrygian in {bottomTonicNote} 
                            <IconEye onClick={()=>{showNotes([11,12])}}/>
                        </li>
                    </ul>
                </div>
            </FlexRowTwo>

        </div>
    )
}